// Logger simple que solo emite en desarrollo. En producción silencia debug/warn.
const isDev = process.env.NODE_ENV === "development";

export const logger = {
  debug: (...args) => { if (isDev) console.debug(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (...args) => { console.error(...args); }, // errores siempre
  info: (...args) => { if (isDev) console.info(...args); },
};
